'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { signIn } from 'next-auth/react';
import { NoSessionPage } from '@/components/app';
import { useUserState } from '@/store';
export const Client = ({
  email
}: {
  email: string;
}) => {
  const [loading, setLoading] = useState(true);
  const [errMsg, setErrMsg] = useState<string | undefined>(undefined);
  const router = useRouter();
  const setUser = useUserState(st => st.setUser);
  useEffect(() => {
    signIn('app-login', {
      email: email.toLowerCase()
    }).then(() => {
      setUser({
        email: email.toLowerCase()
      });
      router.push('/');
    }).catch(() => {
      setLoading(false);
      setErrMsg('Error occurred while logging in (e21)');
    });
  }, [email, router.push, setUser]);
  if (loading) {
    return <div className='h-dvh w-dvw overflow-hidden bg-[#f8f8f8]'>
        <Loading />
      </div>;
  }
  if (errMsg) {
    return <div className='h-dvh w-dvw overflow-hidden bg-[#f8f8f8]'>
        <NoSessionPage message={errMsg} />
      </div>;
  }
  return <div className='h-dvh w-dvw overflow-hidden bg-[#f8f8f8]'>
      <NoSessionPage message='Login failed (e50)' />
    </div>;
};
const Loading = () => {
  return <div className='flex h-dvh w-dvw items-center justify-center'>
      <p>กำลังเข้าสู่ระบบ..</p>
    </div>;
};